/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_Export_HelperInputs */

const en_us2_history_transfer_export_helper = /** @type {(inputs: History_Transfer_Export_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A CSV with every set of every finished workout, in the columns Strong uses. Strong, Hevy and any spreadsheet can open it.`)
};

const pt_br2_history_transfer_export_helper = /** @type {(inputs: History_Transfer_Export_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um CSV com cada série de cada treino concluído, nas colunas do Strong. Dá para abrir no Strong, no Hevy e em qualquer planilha.`)
};

const es_419_history_transfer_export_helper = /** @type {(inputs: History_Transfer_Export_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un CSV con cada serie de cada entrenamiento terminado, con las columnas de Strong. Se puede abrir en Strong, en Hevy y en cualquier hoja de cálculo.`)
};

const pt_pt2_history_transfer_export_helper = /** @type {(inputs: History_Transfer_Export_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um CSV com cada série de cada treino concluído, nas colunas do Strong. Abre no Strong, no Hevy e em qualquer folha de cálculo.`)
};

const fr_fr2_history_transfer_export_helper = /** @type {(inputs: History_Transfer_Export_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un CSV avec chaque série de chaque séance terminée, dans les colonnes de Strong. Strong, Hevy et n'importe quel tableur peuvent l'ouvrir.`)
};

const de_de2_history_transfer_export_helper = /** @type {(inputs: History_Transfer_Export_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine CSV mit jedem Satz jedes abgeschlossenen Trainings, in den Spalten von Strong. Strong, Hevy und jede Tabellenkalkulation können sie öffnen.`)
};

const it_it2_history_transfer_export_helper = /** @type {(inputs: History_Transfer_Export_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un CSV con ogni serie di ogni allenamento concluso, nelle colonne di Strong. Si apre con Strong, Hevy e qualsiasi foglio di calcolo.`)
};

/**
* | output |
* | --- |
* | "A CSV with every set of every finished workout, in the columns Strong uses. Strong, Hevy and any spreadsheet can open it." |
*
* @param {History_Transfer_Export_HelperInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_export_helper = /** @type {((inputs?: History_Transfer_Export_HelperInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Export_HelperInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_export_helper(inputs)
	if (locale === "es-419") return es_419_history_transfer_export_helper(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_export_helper(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_export_helper(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_export_helper(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_export_helper(inputs)
	return en_us2_history_transfer_export_helper(inputs)
});
export { history_transfer_export_helper as "history-transfer.export_helper" }